export enum TaxUnitTypes {
  PERSON = 1,
  COMPANY = 2,
}
